import {ModalAjaxManager} from 'asteq.modals.modalajaxmanager';

export class ModalAjaxButton {
    constructor(options = {}) {
        this.isLoading = false;
        this.el = options.el;

        if (this.el) {
            this.el.addEventListener('click', this.onClick.bind(this));
        }
    }

    setIsLoading(value) {
        this.isLoading = value;
        if (this.el) {
            const sendingClass = 'form-sending';
            if (this.isLoading) {
                this.el.classList.add(sendingClass);
            } else {
                this.el.classList.remove(sendingClass);
            }
        }
    }

    async onClick(e) {
        if (this.isLoading) {
            return;
        }
        const url = this.el.getAttribute('data-local-modal-form');
        if (!url) {
            return;
        }
        this.setIsLoading(true);
        try {
            await ModalAjaxManager.getInstance().loadAndShow(url, {
                isImmediateInDocument: true,
                addClass: this.el.dataset.addClass,
            });
        } catch (e) {
            console.error(e);
        }
        this.setIsLoading(false);
    }

    static initButtons(container = document) {
        container.querySelectorAll('[data-local-modal-form]')
            .forEach((el) => {
                new this({
                    el,
                });
            });
    }
}

BX.ready(() => {
    ModalAjaxButton.initButtons();
});